module.exports = __webpack_public_path__ + "static/media/icone_oeuvreprotestante_taj_old (copie).77139d9f.svg";